<template>
  <div>
    <input v-model="forMarketPlace" type="hidden" name="create_profile_for_marketplace" />
    <button type="submit" class="btn btn-success" @click="forMarketPlace = true">
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      forMarketPlace: false,
    }
  },
}
</script>
